<template>
	<div class="wrap">
		<myHead></myHead>

		<div class="wrap_body" v-loading="is_loading">
			<div class="full-center">
				<div class="center">
					<div class="search_wrap">
						<div class="search_box">

							<span class="type el-dropdown-link">搜档口
							</span>
							<input class="in"
								placeholder="输入档口号或店招名称"
								v-model="searchParams.name" @keyup.enter="refresh()" />
						</div>
						<button class="search_btn" @click.stop="refresh()">搜索</button>
					</div>
					<div class="filter-title" v-if="false">
					<div class="filter-box" :class="showFilter?'show':'hide'">
						<div class="filter-header">
							<div class="header-right" @click="bindFilterShow()">
								<span>隐藏筛选</span>
								<i class="el-icon-arrow-up el-icon--up"></i>
							</div>
						</div>
						<div class="filter-list">
							<div class="label">地区</div>
							<div class="list">
								<div class="item" :class="!searchParams.site_id?'active':''" @click="bindSiteTap(0)">全部</div>
								<div class="item" :class="searchParams.site_id==item.site_id?'active':''" v-for="(item,index) in siteList" :key="index" @click="bindSiteTap(item.site_id)">{{item.site_name}}</div>
							</div>
						</div>
						<div class="filter-list">
							<div class="label">市场</div>
							<div class="list">
								<div class="item" :class="!searchParams.market_id?'active':''" @click.stop="bindMarketTap(0)">全部</div>
								<template v-for="(market,index) in marketList">
									<div class="item" :class="searchParams.market_id==market.market_id?'active':''"
										@click.stop="bindMarketTap(market.market_id)">{{market.market_name}}</div>
								</template>
							</div>
						</div>
						<div class="filter-list">
							<div class="label">类目</div>
							<div class="list">
								<div class="item" :class="!searchParams.cate_id[0]?'active':''" @click.stop="bindCateGroupTab(null)">全部</div>
								<div class="item" v-for="(cate,index) in cateGroupList" :key="index" :class="searchParams.cate_id[0]==cate.cate_ids?'active':''" @click="bindCateGroupTab(cate)">{{cate.name}}</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="center">
			<div class="home_main">

				<div class="product_section">
					<dangkouList style="padding: 0px 20px 20px;" :listData="list" :loading="dangkou_loading" ref="dangkous"></dangkouList>

					<div class="turn_page">
						<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
							@pagination="getDangkou" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20,50,100,200,500,1000]" />
					</div>

				</div>
			</div>
		</div>
	</div>
	<myFoot :showBeian="true"></myFoot>
	</div>
</template>

<script>
	import Vue from 'vue';
	import "swiper/swiper-bundle.min.css";
	import {
		mapActions,
		mapState,
		mapMutations
	} from "vuex";
	import Swiper, {
		Navigation,
		Autoplay
	} from "swiper";
	import myHead from '../../components/myHead/myhead';
	import myFoot from '../../components/myFoot/myfoot';
	import dangkouList from '../../components/dangkouList/dangkouList';
	import common from '../../assets/js/utils/common';
	import headDefault from '../../assets/images/head.png';
	import Pagination from '../../components/pagination/pagination';

	export default {
		name: "shop",
		data() {
			return {
				headDefault,
				input1: '',
				input2: '',
				is_login: false,
				is_register: false,
				login_type: 1,
				reg_step: 1,
				list: [],
				reg_phone: "",
				reg_code: "",
				reg_pwd: "",
				reg_pwd_confirm: "",
				remember_pwd: false,
				is_get_phone_code: false,
				is_reg_submit: false,
				reg_checked: false,
				phone_second: 60,
				imageCode: "",
				login_phone: "",
				login_pwd: "",
				login_code: "",
				is_login_submit: false,
				checkBindTimer: null,
				userId: "",
				loadingCode: false,
				userinfo: "",
				avatar: "",
				is_loading: false,
				dangkou_loading: false,
				cateGroupList: [],
				currGroupName: '',
				subCateList: [],
				market: null,
				searchParams: {
					cate_id: [0, 0],
					site_id: 0,
					market_id: 0,
					sort_type: 0,
					name_type: 0
				},
				page_data: {
					limit: 10,
					page: 1,
					total: 0,
				},
				bannerList: [],
				bannerSwiper: null,
				newsList: [],
				orderCounts: {
					no_pay: 0,
					carry: 0,
					delivery: 0,
					after_sales: 0
				},
				yqm: "",
				yq_grade: "",
				checkList: [],
				marketList: [],
				site_index: 0,
				siteList: [],
				searchText: '',
				showFilter: true,
				filterText: '',
				checkExtList: [],
				ageingList: [],
				publicList: [],
				showPublic: false,
				showAgeing: false,
				ageing_text: '',
				public_text: '',
				timeRange: '',
				showPublicRange: false,

			}
		},
		components: {
			myHead,
			myFoot,
			dangkouList,
			Pagination
		},
		mounted() {
			// this.$nextTick(function () {
			// 	window.addEventListener('scroll', this.onScroll)
			// })
			// this.checkLoginCookie()
		},
		computed: {
			...mapState({
				users: (state) => state.login.userinfo,
				avatars: (state) => state.login.avatar,
				ucmenu: (state) => state.login.ucmenu,
			}),
		},
		created() {
			this.userinfo = this.users ? this.users : ""
			this.avatar = this.avatars || headDefault
			var query = this.$route.query
			if (query.reg) {
				this.is_register = true
				this.yqm = query.yqm
				this.yq_grade = query.yq_grade
			}
			if(query.name_type){
				this.searchParams.name_type = 1
			}
			if(query.name){
				this.searchParams.name = query.name
				this.searchText = query.name
			}
			if(query.site_id){
				this.searchParams.site_id = parseInt(query.site_id)
			}
			if(query.cate_1){
				this.searchParams.cate_id[0] = parseInt(query.cate_1)
			}
			if(query.cate_2){
				this.searchParams.cate_id[1] = parseInt(query.cate_2)
			}
			if(query.market_id){
				this.searchParams.market_id = parseInt(query.market_id)
			}

			if(query.page){
				this.page_data.page = parseInt(query.page)
			}

			this.init()
		},
		destroyed() {
			// window.removeEventListener('scroll', this.onScroll)
		},
		methods: {
			...mapActions({
				getMallCateData: "index/getMallCateData",
				getDangkouList: "index/getDangkouList",
			}),
			...mapMutations({
				OUT_LOGIN: "login/OUT_LOGIN"
			}),

			init() {
				// this.getCateList()
				this.getDangkou()

			},

			gotoIndexSearch() {
				let param = this.searchParams
				this.$router.push({
					name: 'search_index',
					query: param
				})
			},

			//获取商品分类
			getCateList() {
				this.is_loading = true
				this.getMallCateData({
					data: {},
					success: (res) => {
						if (res.code == 200 && res.data.lists.length > 0) {
							this.cateGroupList = res.data.lists
							if(!this.searchParams.cate_id[0]){
								this.subCateList = this.cateGroupList[0].cate_list[0].children
							}else{
								let cateGroup = this.cateGroupList.find(val => val.cate_ids == this.searchParams.cate_id[0])
								this.subCateList = cateGroup.cate_list[0].children
							}
							this.marketList = res.data.market_list
							this.siteList = res.data.site_list
							this.ageingList = res.data.ageing_list
							this.publicList = res.data.public_list
						}
						this.is_loading = false

					}
				})
			},
			//获取商品列表
			getDangkou() {
				if (this.dangkou_loading) return
				this.dangkou_loading = true
				this.list = []
				let searchParams = this.searchParams
				let param = {
					limit: this.page_data.limit,
					page: this.page_data.page,
					state: this.state
				}
				Object.assign(param, searchParams)

				// console.log(param)
				this.getDangkouList({
					data: param,
					success: (res) => {
						if (res.code === 200) {

							this.list = res.data.data
							this.page_data.total = res.data.total
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							});
						}
						this.dangkou_loading = false
						console.log(66655,this.dangkou_loading)

					}
				})
			},
			//滚动加载
			onScroll() {
				// 滚动条到最顶端的距离
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
				let clientHeight = document.documentElement.clientHeight
				let scrollHeight = document.documentElement.scrollHeight
				if (scrolled + clientHeight + 400 >= scrollHeight) {
					this.loadMore()
				}
			},
			//刷新列表
			refresh() {
				this.page_data.page = 1
				this.getDangkou()
				// this.getOrderCount()
			},
			//清空筛选
			reset() {
				this.searchParams.cate_id = [0,0]
				this.searchParams.site_id = 0
				this.searchParams.market_id = 0
				this.subCateList = []

				this.refresh()
			},
			bindFilterShow(){
				this.showFilter = !this.showFilter
			},
			//加载商品
			loadMore() {
				if (this.page_data.total <= this.list.length) {
					return false
				} else {
					this.getDangkou()
				}
			},

			searchTap(name, val) {
				if (!this.searchParams[name] || this.searchParams[name] != val) {
					this.searchParams[name] = val
				} else {
					this.searchParams[name] = 0
				}
				this.refresh()
			},
			siteCommand(val) {
				let siteList = this.siteList
				this.site_index = val
				this.$set(this.searchParams, 'site_id', siteList[val].site_id)
				this.refresh()
			},
			typeCommand(val) {

				// this.refresh()
			},

			bindEventStop() {
				return false;
			},
			bindCateGroupTab(row) {
				if(row){
					this.subCateList = row.cate_list[0].children
					this.searchParams.cate_id[0] = parseInt(row.cate_ids)
				}else{
					this.subCateList = []
					this.searchParams.cate_id[0] = 0
				}
				this.searchParams.cate_id[1] = 0
				this.refresh()
			},

			bindCateTap(second_cid) {
				this.searchParams.cate_id[1] = second_cid
				this.refresh()
			},

		}
	}
</script>

<style scoped>
	.full-center {
		width: 100%;
		background-color: #fff;
		padding: 30px 0 34px
	}

	.home_main {
		width: 100%;
		height: auto;
		margin-top: 20px;
		margin-bottom: 40px;
	}

	.search_wrap {
		margin: 0 auto;
		display: flex;
		justify-content: center;
		font-size: 16px;
	}

	.search_wrap .search_box {
		width: 900px;
		height: 50px;
		box-sizing: border-box;
		background-color: #ffffff;
		border-radius: 4px 0vw 0vw 4px;
		border: solid 2px #fa5757;
		display: flex;
		align-items: center;
	}

	.search_wrap .search_box .type {
		width: 84px;
		color: #333333;
		cursor: pointer;
		text-align: center;
		line-height: 26px;
		border-right: 1px solid #ddd;
	}

	.search_wrap .search_box .in {
		flex: 1;
		width: 0;
		margin: 0 15px;
		color: #333333;
		font-size: 16px;
	}

	.search_wrap .search_box .icon-xiangji {
		margin-right: 14px;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}

	.search_wrap .search_btn {
		width: 132px;
		height: 50px;
		background-image: linear-gradient(180deg, #fa5757 0%, #fb6d6d 100%), linear-gradient(#ffffff, #ffffff);
		background-blend-mode: normal, normal;
		border-radius: 0vw 4px 4px 0vw;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #ffffff;
		font-weight: bold;
		cursor: pointer;
	}

	.filter-title {
	    width: 100%;
	    margin-top: 30px;
	}

	.filter-title .search-input {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	}

	.filter-title .search-input .label {
	    font-size: 14px;
	    color: #666;
	}

	.filter-title .search-input .val {
	    font-size: 14px;
	    color: #333;
	    margin-left: 10px;
	}

	.filter-box {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-orient: vertical;
	    -webkit-box-direction: normal;
	    -ms-flex-direction: column;
	    flex-direction: column;
	    margin-top: 14px;
	    overflow: hidden;
	    width: 1200px;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    background-color: #fff;
	}

	.filter-box .filter-header {
	    -webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    padding: 0 21px;
	    min-height: 46px;
	    background-color: #f9f9f9;
	    border: 1px solid #eee;
	    font-size: 14px;
	    width: 100%;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	}

	.filter-box .filter-header .header-left,.filter-box .filter-header {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	}

	.filter-box .filter-header .header-left .label {
	    font-size: 14px;
	    color: #666;
	}

	.filter-box .filter-header .header-left .val {
	    font-size: 14px;
	    color: #000;
	    margin-left: 20px;
	}

	.filter-box .filter-header .header-left .reset {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    margin-left: 20px;
	    cursor: pointer;
	}

	.filter-box .filter-header .header-left .reset span {
	    color: #fa5757;
	}

	.filter-box .filter-header .header-left .reset i {
	    color: #fa5757;
	    margin-left: 4px;
	}

	.filter-box .filter-header .header-right {
	    cursor: pointer;
	}

	.filter-box .filter-header .header-right i {
	    margin-left: 8px;
	}

	.filter-box .filter-list {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    padding: 0 21px;
	    min-height: 46px;
	    line-height: 46rpx;
	    font-size: 14px;
	    border-bottom: 1px solid #eee;
	    width: 100%;
	    border-left: 1px solid #eee;
	    border-right: 1px solid #eee;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	}

	.filter-box.show {
	    max-height: 1200px;
	    -webkit-transition: all .5s;
	    transition: all .5s;
	    overflow-y: scroll;
	}

	.filter-box::-webkit-scrollbar {
	    width: 0;
	}

	.filter-box.hide {
	    max-height: 46px;
	    -webkit-transition: all .5s;
	    transition: all .5s;
	}

	.filter-box .filter-list .label {
	    width: 55px;
	    line-height: 46px;
	    color: #999;
	}

	.filter-box .filter-list .list {
	    width: calc(100% - 55px);
	}

	.filter-box .filter-list .list .item {
	    line-height: 46px;
	    display: inline-block;
	    margin-right: 50px;
	    color: #333;
	    cursor: pointer;
	}

	.filter-box .filter-list .list .item.active {
	    color: #fa5757;
	}




	.product_section {
	    width: 100%;
	    height: auto;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    background: #fff;
	    margin-top: 20px;
	    padding-top: 20px;
	}

	.product_section .screen_wrap {
	    position: relative;
	    width: calc(100% - 40px);
	    height: 46px;
	    border-bottom: 1px solid #eee;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    margin: 0 20px;
	    background-color: #f9f9f9;
	    border: 1px solid #eee;
	    padding: 0 20px;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	}

	.screen_wrap .title {
	    font-weight: 700;
	    margin-right: 60px;
	}

	.screen_wrap .tab {
	    font-size: 14px;
	    margin-right: 40px;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    cursor: pointer;
	}

	.screen_wrap .tab:hover {
	    color: var(--red);
	    /* text-decoration: underline */
	}


	.screen_wrap .tab.active {
	    color: #fa5757;
	}

	.screen_wrap .in_box {
	    width: 54px;
	    height: 24px;
	    border: 1px solid #ccc;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    padding: 0 6px;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    font-size: 14px;
	    color: #999;
	}

	.screen_wrap .in_box .in {
	    margin-left: 6px;
	}

	.screen_wrap .in_line {
	    width: 20px;
	    color: #999
	}

	.screen_wrap .in_btn,.screen_wrap .in_line {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center
	}

	.screen_wrap .in_btn {
	    margin-left: 12px;
	    width: auto;
	    padding: 0 10px;
	    height: 26px;
	    background: #ddd;
	    cursor: pointer;
	    font-size: 12px;
	    color: #666
	}


	.screen_wrap .totle-text {
	    position: absolute;
	    right: 20px;
	    font-size: 14px;
	    color: #666
	}
</style>
